import { types } from "../action-types";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const vmsFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_VMS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_VMS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload?.vms,
      };
    case types.FETCH_VMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default vmsFilterReducer;
